/** QBO-style decimal input helpers — draft while typing, commit on blur. */

export const parseDecimalInput = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (trimmed === '') return 0;
  // Allow pasted values like "39,000.00"
  const parsed = Number(trimmed.replace(/,/g, ''));
  if (Number.isNaN(parsed)) return null;
  return parsed;
};

export const formatDecimalDisplay = (value: number, decimals = 2): string => {
  if (!Number.isFinite(value)) return '';
  return String(Number(value.toFixed(decimals)));
};

export const clampDecimal = (value: number, min?: number, max?: number): number => {
  let result = value;
  if (min !== undefined && result < min) result = min;
  if (max !== undefined && result > max) result = max;
  return result;
};

/** Blur the focused element so DecimalInput drafts commit before save/validate. */
export const blurActiveInputBeforeSave = (): void => {
  const active = document.activeElement;
  if (active instanceof HTMLElement) {
    active.blur();
  }
};
